import moment from 'moment-timezone'

export function formatMomentObject(dateString) {
	let momentObj = moment(moment.utc(dateString))
	//let momentObj = moment(moment.utc(dateString).local());

	// let momentObj = moment(moment.utc(dateString));
	return momentObj.isValid() ? momentObj : null
}

export function formatMomentString(dateString, formatString = 'MMMM D Y hh:mm:ss a') {
	let momentString = moment(
		moment
			.utc(dateString)
			.local()
			.format()
	)
	return momentString.isValid() ? momentString.format(formatString) : ''
}



// WEBPACK FOOTER //
// ./src/utils/dateHelpers.js